import React, { useCallback, useMemo } from 'react'
import {
  Table,
  ColumnProps,
  DeleteHandler,
  DangerLink,
  modalDanger,
} from 'admin-web-ui'
import { SafetyNetPackageName } from '../../../../../api'

interface PackageName {
  id: string
  packageName: string
}

function makeColumns(opts: {
  onRemove: DeleteHandler
}): ColumnProps<PackageName>[] {
  return [
    {
      key: 'packageName',
      title: 'Package Name',
      dataIndex: 'packageName',
    },
    {
      key: 'actions',
      title: <span style={{ visibility: 'hidden' }}>{'Actions'}</span>,
      dataIndex: 'packageName',
      align: 'right',
      render(_, packageNameInfo) {
        return (
          <DangerLink
            onClick={() => opts.onRemove(packageNameInfo.packageName)}
            className="automation-removePackageNameButton"
          >
            Remove
          </DangerLink>
        )
      },
    },
  ]
}

interface Props {
  className?: string
  packageNames: SafetyNetPackageName[]
  loading: boolean
  onDelete: (packageName: string) => void
}

export const PackageNameWhitelistingList: React.FC<Props> = (props) => {
  const { className, packageNames, loading, onDelete: onRemove } = props
  const removeButtonHandler = useCallback(
    (packageName: string): void => {
      modalDanger({
        title: 'Remove Package Name',
        content: (
          <p>
            Removing a package name cannot be undone. When this package name is
            revoked it will no longer work. Are you sure you wanted to remove
            this package name?
          </p>
        ),
        onOk: () => onRemove(packageName),
      })
    },
    [onRemove],
  )

  const columns = useMemo(
    () =>
      makeColumns({
        onRemove: removeButtonHandler,
      }),
    [removeButtonHandler],
  )
  const packageNamesWithId = packageNames.map((pn, i) => ({
    ...pn,
    id: `${pn.packageName}_${i}`,
  }))

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={packageNamesWithId}
      loading={loading}
      rowKey="id"
    />
  )
}
